import { render, staticRenderFns } from "./HotTopicsPage.vue?vue&type=template&id=b4d52690"
import script from "./HotTopicsPage.vue?vue&type=script&lang=ts"
export * from "./HotTopicsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports